import React, { memo } from 'react';
// import CKEditor from '@ckeditor/ckeditor5-react';
import CKEditor from 'ckeditor4-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Box, InputLabel } from '@material-ui/core';
import './style.css';

CKEditor.editorUrl = 'https://cdn.ckeditor.com/4.13.0/full/ckeditor.js';
// const WYSIWYG = props => (
//   <div>
//     <Box mb={1}>
//       <InputLabel>{props.label}</InputLabel>
//     </Box>
//     <CKEditor
//       editor={ClassicEditor}
//       data={props.value}
//       onChange={(event, editor) => {
//         const data = editor.getData();
//         console.log({ event, editor, data });
//         props.onChange({ data });
//       }}
//       onBlur={(event, editor) => {
//         console.log('Blur.', editor);
//       }}
//       onFocus={(event, editor) => {
//         console.log('Focus.', editor);
//       }}
//     />
//   </div>
// );
const WYSIWYG = props => (
  <div>
    <Box mb={1}>
      <InputLabel>{props.label}</InputLabel>
    </Box>
    <CKEditor
      data={props.value}
      onChange={event => {
        const data = event.editor.getData();
        props.onChange({ data });
      }}
    />
  </div>
);

export default memo(WYSIWYG, () => true);
